// The Inbox's live connection (Server-Sent Events) that never stays lost. The browser reconnects by itself only when the
// connection drops; when Kolvantage restarts for an update, the proxy can answer the retry with an error while the hub is still
// starting, and the browser then gives up for good: the agent shows offline until the page is reloaded. This reopens it,
// and also when the connection went silent (no heartbeat) or the computer woke up or got its network back.
//
//   const source = liveSource('/api/chat/stream');   // used like an EventSource: addEventListener(type, fn)

export const SILENT_MS = 70000; // the hub sends a heartbeat every 20 s
const CHECK_MS = 10000;

export function liveSource(url) {
  const listeners = [];
  let native = null;
  let lastSeen = 0;
  let retry = 0;
  let timer = null;

  const attach = (type, fn) => native.addEventListener(type, (e) => {
    lastSeen = Date.now();
    fn(e);
  });

  const open = () => {
    clearTimeout(timer);
    try {
      native?.close();
    } catch {
      // already closed
    }
    lastSeen = Date.now();
    native = new EventSource(url);
    for (const [type, fn] of listeners) attach(type, fn);
    native.addEventListener('open', () => {
      retry = 0;
    });
    native.addEventListener('hb', () => {
      lastSeen = Date.now();
    });
    native.addEventListener('error', () => {
      // CLOSED: the browser won't retry on its own (an error answer while the hub restarts): try again soon, a little slower each time
      if (native.readyState !== 2) return;
      timer = setTimeout(open, Math.min(2000 * 2 ** retry++, 15000));
    });
  };

  const check = () => {
    if (!native) return;
    if (native.readyState === 2 && !timer) open();
    else if (native.readyState === 1 && Date.now() - lastSeen > SILENT_MS) open();
  };
  setInterval(check, CHECK_MS);
  addEventListener('online', open);
  document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && check());

  open();
  return {
    addEventListener(type, fn) {
      listeners.push([type, fn]);
      attach(type, fn);
    },
  };
}
